// extracted by mini-css-extract-plugin
export var errorIcon = "_qw-1";
export var nameLogo = "_qw-0";